import type { ReactElement } from 'react';
import { TaxreturnApproval } from './TaxreturnApproval';
import { TaxreturnFilingStatus } from './TaxreturnFilingStatus';
import { TaxreturnIxbrl } from './TaxreturnIxbrl';
import { TaxreturnReviewpoints } from './TaxreturnReviewpoints';
import { TaxreturnRevisions } from './TaxreturnRevisions';
import { TaxreturnTaskSubmit } from './TaxreturnTaskSubmit';
import { TaxreturnTaskSubmitList } from './TaxreturnTaskSubmitList';
import { TaxreturnTaxHandoff } from './TaxreturnTaxHandoff';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/tasks-reviewpoints': <TaxreturnReviewpoints />,
  '/home/taxreturns/tasks-approval': <TaxreturnApproval />,
  '/home/taxreturns/revisions-lineage': <TaxreturnRevisions />,
  // One component on two URLs: the tab is chosen from the URL when it opens, and Angular built a fresh component when
  // moving between the two routes, hence the keys.
  '/home/taxreturns/ixbrl-facts': <TaxreturnIxbrl key="ixbrl-facts" />,
  '/home/taxreturns/ixbrl-exceptions': <TaxreturnIxbrl key="ixbrl-exceptions" />,
  '/home/taxreturns/filing-status': <TaxreturnFilingStatus />,
  '/home/taxreturns/tax-handoff': <TaxreturnTaxHandoff />,
  '/home/taxreturns/tasks-submit': <TaxreturnTaskSubmit />,
  '/home/taxreturns/submitlist': <TaxreturnTaskSubmitList />,
};
